const popin = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M7.065 7.875 13.26 1.68l1.06 1.06-6.195 6.195L10.19 11H5V5.81zM15 15H1V1h1.65v12.35H15z"/></svg>',
};

export { popin as default };
